// extracted by mini-css-extract-plugin
export default {"notificationCount":"DueVaccineIcon_notificationCount__RGERq"};